var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'qrcodeResult',
    data: function () {
        return {
            times: 0,
            current: {},
            results: {
                SUCCESS: {
                    imgUrl: require('../../assets/images/console-common/common-status-success.svg'),
                    statusTitle: '购买成功',
                    status: 'SUCCESS',
                    statusDes: '',
                    titleMarginBottom: '5px',
                    listModelMarginBottom: '77px',
                    list: [],
                    btnTxt: '查看购买记录',
                    btnCallbackName: 'toPurchaseRecord',
                },
                WIENER: {
                    imgUrl: require('../../assets/images/console-common/common-status-pending.svg'),
                    statusTitle: '购买中',
                    status: 'WIENER',
                    statusDes: '查询条数更新中，您可在购买记录中查看',
                    list: [],
                    listModelMarginBottom: '77px',
                    btnTxt: '查看购买记录',
                    btnCallbackName: 'toPurchaseRecord',
                },
                FAIL: {
                    imgUrl: require('../../assets/images/console-common/common-status-fail.svg'),
                    statusTitle: '购买失败',
                    status: 'FAIL',
                    statusDes: '失败原因啊',
                    list: [],
                    btnTxt: '重新购买',
                    btnCallbackName: 'toPayform',
                },
            },
        };
    },
    computed: __assign({}, mapState('violationManage', {
        qrStatus: 'qrStatus',
    })),
    created: function () {
        this.getDetail(this.qrStatus);
    },
    methods: {
        toPurchaseRecord: function () {
            this.$router.push({ name: 'violationPurchaseRecord' });
        },
        toPayform: function () {
            var times = this.times;
            var active = 'payform';
            this.$emit('to-buy', {
                times: times,
                active: active,
            });
        },
        commonOpe: function (name) {
            this[name]();
        },
        getDetail: function (StatusMsg) {
            var _this = this;
            if (!StatusMsg)
                return;
            var status = StatusMsg.status, purchaseCode = StatusMsg.purchaseCode;
            this.$request({
                url: '/proxy/violation/purchase/detail',
                method: 'post',
                data: { purchaseCode: purchaseCode },
            }).then(function (res) {
                if (!res)
                    return;
                if (res.errorCode === 0) {
                    _this.showResult(res.data, status);
                }
            });
        },
        showResult: function (data, status) {
            var failReason = data.failReason, purchaseCode = data.purchaseCode, amount = data.amount, times = data.times, payTime = data.payTime;
            var list = [
                { name: '订单号', val: purchaseCode },
                { name: '支付金额', val: toYuan(amount) + "\u5143" },
                { name: '购买条数', val: times + "\u6761" },
                {
                    name: '支付时间',
                    val: moment(payTime).format('YYYY-MM-DD HH:mm:ss'),
                },
            ];
            this.times = times;
            this.current = this.results[status];
            this.current.list = list;
            this.current.statusDes = failReason;
        },
    },
});
